<template>
  <span
    :class="{
      '[&_a]:text-blue-600 [&_a]:underline hover:[&_a]:text-blue-800': applyLinkStyles,
    }"
    v-html="sanitizedHtml"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import DOMPurify from 'dompurify'

const props = defineProps<{
  html: string
  applyLinkStyles?: boolean
  allowLinkTarget?: boolean
}>()

const sanitizedHtml = computed(() => {
  return props.applyLinkStyles || props.allowLinkTarget
    ? DOMPurify.sanitize(props.html, { ADD_ATTR: ['target'] })
    : DOMPurify.sanitize(props.html)
})
</script>
